import ObjectHelper from 'utils/ObjectHelper';
const demoConfig = {
  svcHost: ObjectHelper.isDspLogon()
    ? process.env.REACT_APP_API_HOST_DSP
    : process.env.REACT_APP_API_HOST,

  getDemoData: {
    method: 'GET',
    url: '/demo/getDemo.json',
    timeout: 30000,
  },
  saveDemoData: {
    method: 'POST',
    url: '/demo/saveDemo.json',
    timeout: 30000,
  },
};

export default demoConfig;
